'use strict';

import { addClassToElement, removeClassToElement } from '@jspartials/class-list-utils';

// Classes
const HELLOBAR_CLASSNAME = 'js-hellobar';
const HELLOBAR_MESSAGE_CLASSNAME = 'js-hellobar__message';
const ANIMATED_IN_CLASSNAME = 'animated-in';
const ANIMATED_OUT_CLASSNAME = 'animated-out';

// Selectors
const HELLOBAR_SELECTOR = `.${HELLOBAR_CLASSNAME}`;
const HELLOBAR_MESSAGE_SELECTOR = `.${HELLOBAR_MESSAGE_CLASSNAME}`;

// Elements
const hellobar = document.querySelector(HELLOBAR_SELECTOR);

// Variables
const timeToResetMessage = 600;
const defaultTimeBetweenMessages = 5000;
const timeBetweenMessages = hellobar ? hellobar.dataset.timeBetweenMessages : defaultTimeBetweenMessages;
const updateMessagesHellobarEvent = 'updateMessagesHellobar';
let animationBetweenMessages = null;
let totalMessages = 0;
let count = 0;

function animate() {
  animateOut();
  animateIn();

  setTimeout(function(){
    const bothClasses = document.querySelector(`.${HELLOBAR_MESSAGE_CLASSNAME}.${ANIMATED_IN_CLASSNAME}.${ANIMATED_OUT_CLASSNAME}`);
    removeClassToElement(bothClasses, ANIMATED_IN_CLASSNAME, ANIMATED_OUT_CLASSNAME);
  }, timeToResetMessage);
}

function getIndexNextElement() {
  const nextIndex = count + 1;
  return (nextIndex < totalMessages) ? nextIndex : 0;
}

function getMessageByIndex(index) {
  return document.querySelector(`.${HELLOBAR_MESSAGE_CLASSNAME}[data-index="${index}"]`);
}

function animateIn() {
  const indexNextElement = getIndexNextElement();
  const nextElement = getMessageByIndex(indexNextElement);
  addClassToElement(nextElement, ANIMATED_IN_CLASSNAME);
}

function animateOut() {
  const actualElement = getMessageByIndex(count);
  addClassToElement(actualElement, ANIMATED_OUT_CLASSNAME);

}

function initHelloBar() {
  totalMessages = 0;
  setHellobarMessages();
  if(totalMessages > 1) {
    animationBetweenMessages = setInterval(() => {
      animate();
      count = getIndexNextElement();
    }, timeBetweenMessages);
  } else {
    if(animationBetweenMessages){
      clearInterval(animationBetweenMessages);
    }
  }
}

function setHellobarMessages() {
  const hellobarMessages = document.querySelectorAll(HELLOBAR_MESSAGE_SELECTOR);
  hellobarMessages.forEach((hellobarMessage, index) => {
    hellobarMessage.dataset.index = index;
    if (index === 0) {
      addClassToElement(hellobarMessage, ANIMATED_IN_CLASSNAME);
    }
    totalMessages++;
  });
}

document.addEventListener('DOMContentLoaded', function() {
  if (hellobar) {
    initHelloBar();

    // Event
    hellobar.addEventListener(updateMessagesHellobarEvent, () => {
      initHelloBar();
    });
  }
});
